import Providers from "./providers";
import Routes from "routes";
import OneSignal from "react-onesignal";
import { useEffect, useRef } from "react";

export default function App() {
    const initialized = useRef(false);
    const appId = process.env.REACT_APP_ONESIGNAL_APP_ID

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;

            OneSignal.init({
                appId: appId,
                safari_web_id: "web.onesignal.auto.02091d44-51df-4a38-967b-45e7d1e7feaf",
                allowLocalhostAsSecureOrigin: true,
                notifyButton: { enabled: false },
                welcomeNotification: { disable: true }
            })
                .catch(error => console.error("OneSignal error:", error));
        }
    }, []);

    return (
        <Providers>
            <Routes />
        </Providers>
    );
}